export const englishFontFallbackMap = {
    'Poppins': "'Poppins', sans-serif",
    'Zain': "'Zain', sans-serif",
    'Open Sans': "'Open Sans', sans-serif",
    'Quicksand': "'Quicksand', sans-serif",
    'Lato': "'Lato', sans-serif",
    'Mooli': "'Mooli', sans-serif",
    'DM Serif': "'DM Serif', serif",
    'Roboto Serif': "'Roboto Serif', serif",
    'Ysabeau': "'Ysabeau', sans-serif",
    'Kalam': "'Kalam', cursive",
};

export const arabicFontFallbackMap = {
    'Cairo': "'Cairo', sans-serif",
    'Tajawal': "'Tajawal', sans-serif",
    'IBMPlexSansArabic': "'IBMPlexSansArabic', sans-serif",
    'Beiruti': "'Beiruti', sans-serif", // custom style; assumed modern
    'DinNext': "'DinNext', sans-serif",
    'ExpoArabic': "'ExpoArabic', sans-serif",
    'Tanseek': "'Tanseek', sans-serif",
    'Mada': "'Mada', sans-serif",
    'Markazi': "'Markazi', serif", // Markazi is Naskh-style, closer to serif
    'Zain': "'Zain', sans-serif" // assuming modern display font
  };